// extracted by mini-css-extract-plugin
export default {"bar":"ScrollProgress_bar__9s0eW"};